import { inject, observer } from "mobx-react";
import { useEffect, useState } from "react";
import "./result.css";
import { Button, List, Tag, Row, Col, Card } from "antd";
import { PlusOutlined, CheckOutlined } from "@ant-design/icons";
import * as echarts from "echarts";
import TextArea from "antd/lib/input/TextArea";
import { Chip, Divider, Grid, Paper, Slider, Typography } from "@mui/material";
import StyledHeader from "../../../components/StyledHeader/StyledHeader";
import {
  AddRounded,
  CheckRounded,
  QueryStatsRounded,
} from "@mui/icons-material";
import { Box } from "@mui/system";

export default function Result({ results }) {
  const [model, setModel] = useState(null);
  const [title_list, setTitle_list] = useState(null);
  const [sequence_list, setSequence_list] = useState(null);
  const [prediction_list, setPrediction_list] = useState(null);
  const [prediction_list8, setPrediction_list8] = useState(null);
  const [residue_number, setResidue_number] = useState(null);
  const [SS_number, setSS_number] = useState(null);
  const [SS_number8, setSS_number8] = useState(null);

  const [sequenceList, setSequenceList] = useState([]);
  const [TagShowList, setTagShowList] = useState([]);
  const [showSeq, setShowSeq] = useState([0]);
  const [sWidth, setSWidth] = useState([13]);
  const [showCardList, setShowCardList] = useState([]);
  useEffect(() => {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    console.log("results:", results);
  }, []);

  const residues = [
    "A",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "K",
    "L",
    "M",
    "N",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "V",
    "W",
    "Y",
  ];
  const color_residues = {
    A: "#FD776A",
    R: "darkgoldenrod",
    N: "#E35F7A",
    D: "#FB75D3",
    C: "#FFB287",
    Q: "#E87B99",
    E: "#FF0070",
    G: "#E89D66",
    H: "#FF483C",
    I: "#A4E887",
    L: "#FF8957",
    K: "#94E4FF",
    M: "#82E8C0",
    F: "#9EA4FF",
    P: "#5A67FF",
    S: "#DEA1FF",
    T: "#8F8EE8",
    W: "#A9DDFF",
    Y: "#8EE8D3",
    V: "#FF948F",
  };
  const SSprediction = ["H", "E", "C"];
  const SSprediction_color = {
    H: "#C339D7",

    E: "#FF9700",

    C: "#60CBD1",
  };

  const SSprediction8 = ["H", "B", "E", "G", "I", "T", "S", "C"];
  const SSprediction8_color = {
    H: "#C339D7",
    B: "#E8BB5D",
    E: "#FF9700",
    G: "#AD5DE8",
    I: "#66BCFF",
    T: "#1F7D73",
    S: "#FF7978",
    C: "#FF443C",
  };
  const bar_graph = (data, domId) => {
    var chartDomBar = document.getElementById(domId);
    var myChartBar = echarts.init(chartDomBar);
    var optionBar;

    optionBar = {
      xAxis: {
        type: "category",
        data: residues,
      },
      yAxis: {
        type: "value",
      },
      label: {
        show: true,
        position: "top",
      },
      series: [
        {
          data: data,
          type: "bar",
        },
      ],
    };
    myChartBar.setOption(optionBar);
  };
  const pie_graph = (data, domId, title, legend) => {
    let chartDom = document.getElementById(domId);
    let myChart = echarts.init(chartDom);
    let option;

    option = {
      title: {
        text: title,
        left: "center",
      },
      tooltip: {
        trigger: "item",
      },
      legend: {
        orient: "vertical",
        left: "left",
      },
      series: [
        {
          name: legend,
          type: "pie",
          radius: "75%",

          label: {
            show: false,
            position: "center",
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
          labelLine: {
            show: false,
          },
          data: data,
        },
      ],
    };

    myChart.setOption(option);
  };
  useEffect(() => {
    if (residue_number) {
      let sum_number = 0;
      residues.forEach((value) => {
        sum_number += residue_number[value];
      });
      let pie_data = residues.map((value) => {
        return {
          name: value,
          value: (residue_number[value] / sum_number).toFixed(3),
          itemStyle: {
            color: color_residues[value],
          },
        };
      });
      let bar_data = residues.map((value) => {
        return {
          value: residue_number[value],
          itemStyle: {
            color: color_residues[value],
          },
        };
      });
      try {
        pie_graph(
          pie_data,
          "echart_entrence1",
          "Residue ratio chart",
          "Residue ratio"
        );
        bar_graph(bar_data, "echart_entrence2");
      } catch (error) {}
    }
  }, [residue_number]);
  useEffect(() => {
    if (SS_number) {
      let sum_number = 0;
      SSprediction.forEach((value) => {
        sum_number += SS_number[value];
      });
      let pie_data = SSprediction.map((value) => {
        return {
          name: value,
          value: (SS_number[value] / sum_number).toFixed(3),
          itemStyle: {
            color: SSprediction_color[value],
          },
        };
      });

      try {
        pie_graph(
          pie_data,
          "echart_entrence3",
          "3-state Secondary Structure ratio chart",
          "Secondary Structure ratio"
        );
      } catch (error) {}
    }
  }, [SS_number]);
  useEffect(() => {
    if (SS_number8 && model && model === 5) {
      let sum_number = 0;
      SSprediction8.forEach((value) => {
        sum_number += SS_number8[value];
      });
      let pie_data = SSprediction8.map((value) => {
        return {
          name: value,
          value: (SS_number8[value] / sum_number).toFixed(3),
          itemStyle: {
            color: SSprediction8_color[value],
          },
        };
      });

      try {
        pie_graph(
          pie_data,
          "echart_entrence4",
          "8-state Secondary Structure ratio chart",
          "Secondary Structure ratio"
        );
      } catch (error) {}
    }
  }, [SS_number8]);
  useEffect(() => {
    setTitle_list(results.table_data?.title_list);
    setSequence_list(results.table_data?.sequence_list);
    setPrediction_list(results.table_data?.prediction_list);
    setPrediction_list8(results.table_data?.prediction_list8);
    setResidue_number(results.table_data?.residue_number);
    setSS_number(results.table_data?.SS_number);
    setSS_number8(results.table_data?.SS_number8);
    setModel(results.modelID);
  }, [
    results.table_data?.title_list,
    results.table_data?.sequence_list,
    results.table_data?.prediction_list,
    results.table_data?.prediction_list8,
    results.table_data?.residue_number,
    results.table_data?.SS_number,
    results.table_data?.SS_number8,
    results.modelID,
  ]);

  useEffect(() => {
    if (sequence_list) {
      let current_seq = [];
      let current_Tag = [];
      sequence_list.forEach((element, index) => {
        current_seq.push(element.split(""));
        current_Tag.push({
          value: index,
          label: title_list[index],
        });
      });
      setSequenceList(current_seq);
      setTagShowList(current_Tag);
    }
  }, [model, title_list, sequence_list, prediction_list, prediction_list8]);

  const colorResidue = (residue) => {
    if (color_residues[residue]) {
      return color_residues[residue];
    } else {
      return "purple";
    }
  };
  const colorStructure = (structure) => {
    if (SSprediction_color[structure]) {
      return SSprediction_color[structure];
    } else {
      return "";
    }
  };

  const colorStructure8 = (structure) => {
    if (SSprediction8_color[structure]) {
      return SSprediction8_color[structure];
    } else {
      return "";
    }
  };
  useEffect(() => {
    let sequence_body_con_div = [];
    sequenceList.forEach((value, index, array) => {
      if (showSeq.length > 0 && showSeq[0] === index) {
        value.map((v, i, a) => {
          let SS_color = "";
          let SS_color8 = "";
          let seq_color = colorResidue(v);

          if (model && model === 4)
            SS_color = colorStructure(prediction_list[index][i]);

          if (model && model === 5)
            SS_color8 = colorStructure8(prediction_list8[index][i]);

          sequence_body_con_div.push(
            <Box
              sx={{
                pt: "20px",
                float: "left",
                minHeight: "100px",
              }}
              key={i}
            >
              <div
                style={{
                  color: `${seq_color}`,
                  width: `${sWidth}px`,
                  backgroundColor: `${sWidth < 10 ? seq_color : "#f6f6f6"}`,
                  fontSize: "15px",
                  textAlign: "center",
                }}
              >
                {sWidth < 10 ? "." : v}
              </div>
              <Divider />
              {model && model === 4 && (
                <div
                  style={{
                    color: `${SS_color}`,
                    width: `${sWidth}px`,
                    backgroundColor: `${sWidth < 10 ? SS_color : ""}`,
                    fontSize: "15px",
                    textAlign: "center",
                  }}
                >
                  {sWidth < 10 ? "." : prediction_list[index][i]}
                </div>
              )}
              <Divider />
              {model && model === 5 && (
                <div
                  style={{
                    color: `${SS_color8}`,
                    width: `${sWidth}px`,
                    backgroundColor: `${sWidth < 10 ? SS_color8 : ""}`,
                    fontSize: "15px",
                    textAlign: "center",
                  }}
                >
                  {sWidth < 10 ? "." : prediction_list8[index][i]}
                </div>
              )}
            </Box>
          );
        });
      }
    });

    setShowCardList(sequence_body_con_div);
  }, [sequenceList, sWidth, showSeq]);

  const handleSeqChange = (id) => {
    if (showSeq[0] === id) setShowSeq([]);
    else setShowSeq([id]);
  };

  const TextAreaState = (state) => {
    if (state === 4)
      return (
        <div className="TextAreaState">
          <StyledHeader icon={<QueryStatsRounded />}>
            3-state peptide secondary structure
          </StyledHeader>
          <Box sx={{ m: 3 }}>
            <TextArea
              style={{ width: "100%" }}
              value={
                results.table_data.seqOutput ? results.table_data.seqOutput : ""
              }
              autoSize={{ minRows: 10, maxRows: 20 }}
              bordered={false}
            />
          </Box>
        </div>
      );
    else
      return (
        <div className="TextAreaState">
          <StyledHeader icon={<QueryStatsRounded />}>
            8-state peptide secondary structure
          </StyledHeader>
          <Box sx={{ m: 3 }}>
            <TextArea
              style={{ width: "100%" }}
              value={
                results.table_data.seqOutput8
                  ? results.table_data.seqOutput8
                  : ""
              }
              bordered={false}
              autoSize={{ minRows: 5, maxRows: 10 }}
            />
          </Box>
        </div>
      );
  };

  return (
    <div className="Result-Result-body">
      <Paper elevation={3} sx={{ overflow: "hidden", mb: 2 }}>
        <StyledHeader icon={<QueryStatsRounded />}>
          Statistics Analysis
        </StyledHeader>
        <Box sx={{ m: 5 }}>
          <Box
            id="echart_entrence1"
            style={{ width: "50%", height: "400px", float: "left" }}
          ></Box>
          <Box
            id="echart_entrence2"
            style={{ width: "50%", height: "400px", float: "left" }}
          ></Box>
        </Box>
      </Paper>
      <Paper elevation={3} sx={{ overflow: "hidden", mb: 2 }}>
        <div className="TextAreaState">{TextAreaState(results.modelID)}</div>
      </Paper>
      <Paper elevation={3} sx={{ overflow: "hidden", mb: 2 }}>
        <StyledHeader icon={<QueryStatsRounded />}>
          Sequences with visualization
        </StyledHeader>

        <div
          style={{
            width: "95%",
            margin: "10px auto",
            overflowX: "auto",
          }}
        >
          <div style={{ width: "max-content" }}>
            {TagShowList &&
              TagShowList.map((seq) => {
                let selected = showSeq.includes(seq.value);
                return (
                  <Chip
                    icon={selected ? <CheckRounded /> : <AddRounded />}
                    key={seq.value}
                    label={seq.label}
                    color={selected ? "primary" : "default"}
                    disabled={showSeq.length > 0 && !selected}
                    onClick={() => handleSeqChange(seq.value)}
                    sx={{ m: "3px 5px" }}
                  />
                );
              })}
          </div>
        </div>

        <Box sx={{ m: 3 }}>
          <Slider
            track={false}
            min={1}
            max={100}
            step={0.5}
            marks={[
              { value: 1, label: "1%" },
              { value: 100, label: "100%" },
            ]}
            getAriaValueText={(value, index) =>
              `#${index + 1} ${value.toFixed(2)}`
            }
            valueLabelFormat={(value, index) =>
              `#${index + 1} ${value.toFixed(2)}`
            }
            valueLabelDisplay="auto"
            value={sWidth}
            onChange={(_e, value) => setSWidth(value)}
            aria-labelledby="option-cd-hint-group-label"
          />
        </Box>
        <Divider />
        {showSeq.length > 0 && (
          <Box sx={5}>
            <div
              style={{
                width: "95%",
                height: "150px",
                margin: "0 auto",
                overflowX: "auto",
              }}
            >
              <Grid container>
                <Grid item xs={2}>
                  <Box
                    sx={{
                      pt: "20px",
                    }}
                  >
                    <Box>Sequence</Box>
                    <Divider />
                    <Box>Structure</Box>
                    <Divider />
                  </Box>
                </Grid>
                <Grid item xs={10}>
                  <div style={{ width: "max-content" }}>{showCardList}</div>
                </Grid>
              </Grid>
            </div>
          </Box>
        )}
      </Paper>
      <Paper elevation={3} sx={{ overflow: "hidden", mb: 2 }}>
        <StyledHeader icon={<QueryStatsRounded />}>
          Prediction Analysis
        </StyledHeader>
        <Box sx={{ m: 5 }}>
          {SS_number && model && model === 4 && (
            <div
              id="echart_entrence3"
              style={{ width: "50%", height: "400px", float: "left" }}
            ></div>
          )}

          {SS_number8 && model && model === 5 && (
            <div
              id="echart_entrence4"
              style={{ width: "50%", height: "400px", float: "left" }}
            ></div>
          )}
        </Box>
      </Paper>
    </div>
  );
}
